import { useEffect, useRef } from 'react'

/** Fires when the sentinel enters the viewport (used to load the next page of directory results). */
export function DirectoryLoadMoreSentinel({
  onLoadMore,
  active,
}: {
  onLoadMore: () => void
  active: boolean
}) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el || !active) return

    const obs = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) onLoadMore()
      },
      { rootMargin: '400px' },
    )
    obs.observe(el)
    return () => obs.disconnect()
  }, [onLoadMore, active])

  return <div ref={ref} className="h-1 w-full shrink-0" aria-hidden />
}
